// src/components/ui/Icon/index.tsx
import React from "react";

// Paths portados 1:1 de menuchef-prototype/components.jsx (ICON_PATHS).
export const ICON_PATHS: Record<string, React.ReactNode> = {
  cart: (
    <>
      <circle cx="9" cy="21" r="1.6" />
      <circle cx="18" cy="21" r="1.6" />
      <path d="M2.5 3h2.2l2.3 12.4a2 2 0 0 0 2 1.6h8.4a2 2 0 0 0 2-1.6L21 7H6" />
    </>
  ),
  bag: (
    <>
      <path d="M5 8h14l-1 12.5a1.5 1.5 0 0 1-1.5 1.4h-9A1.5 1.5 0 0 1 6 20.5L5 8Z" />
      <path d="M8.5 8V6.5a3.5 3.5 0 0 1 7 0V8" />
    </>
  ),
  plus: <path d="M12 5v14M5 12h14" />,
  minus: <path d="M5 12h14" />,
  search: (
    <>
      <circle cx="11" cy="11" r="7" />
      <path d="m20 20-3.2-3.2" />
    </>
  ),
  pin: (
    <>
      <path d="M12 21s7-5.8 7-11a7 7 0 1 0-14 0c0 5.2 7 11 7 11Z" />
      <circle cx="12" cy="10" r="2.6" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M12 7.5V12l3 1.8" />
    </>
  ),
  moto: (
    <>
      <circle cx="5.5" cy="17.5" r="3" />
      <circle cx="18.5" cy="17.5" r="3" />
      <path d="M8.5 17.5h6l2.5-6h-4l-1.5-3H8" />
    </>
  ),
  star: <path d="M12 3.5l2.6 5.3 5.9.85-4.25 4.15 1 5.85L12 17.1l-5.25 2.4 1-5.85L3.5 9.65l5.9-.85L12 3.5Z" />,
  chevron: <path d="m9 6 6 6-6 6" />,
  chevronDown: <path d="m6 9 6 6 6-6" />,
  x: <path d="M6 6l12 12M18 6 6 18" />,
  user: (
    <>
      <circle cx="12" cy="8" r="3.6" />
      <path d="M5 20c0-3.6 3.1-5.6 7-5.6s7 2 7 5.6" />
    </>
  ),
  check: <path d="m5 12.5 4.5 4.5L19 7" />,
  trash: (
    <>
      <path d="M4 7h16" />
      <path d="M9 7V5.5A1.5 1.5 0 0 1 10.5 4h3A1.5 1.5 0 0 1 15 5.5V7" />
      <path d="m6.5 7 .8 12.2a1.6 1.6 0 0 0 1.6 1.5h6.2a1.6 1.6 0 0 0 1.6-1.5L18.5 7" />
    </>
  ),
  pencil: (
    <>
      <path d="M4 20h4L18.5 9.5a2 2 0 0 0 0-2.8l-1.2-1.2a2 2 0 0 0-2.8 0L4 16v4Z" />
      <path d="M13.5 6.5 17.5 10.5" />
    </>
  ),
  phone: <path d="M6.5 4h3l1.5 4-2 1.5a12 12 0 0 0 5 5l1.5-2 4 1.5v3a2 2 0 0 1-2 2A16 16 0 0 1 4.5 6a2 2 0 0 1 2-2Z" />,
  card: (
    <>
      <rect x="3" y="5.5" width="18" height="13" rx="2.5" />
      <path d="M3 9.5h18" />
    </>
  ),
  pix: <path d="M12 3.5 20.5 12 12 20.5 3.5 12 12 3.5Z" />,
  money: (
    <>
      <rect x="3" y="6" width="18" height="12" rx="2" />
      <circle cx="12" cy="12" r="2.6" />
    </>
  ),
  image: (
    <>
      <rect x="3.5" y="4.5" width="17" height="15" rx="2.5" />
      <circle cx="9" cy="10" r="1.8" />
      <path d="m5 18 4.5-4.5 3 3L16 12l4 5" />
    </>
  ),
  info: (
    <>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 11v5" />
      <circle cx="12" cy="7.6" r="0.4" />
    </>
  ),
  back: <path d="m15 6-6 6 6 6" />,
  receipt: (
    <>
      <path d="M6 3h12v18l-2-1.3-2 1.3-2-1.3-2 1.3-2-1.3L6 21V3Z" />
      <path d="M9 8h6M9 12h6" />
    </>
  ),
  utensils: (
    <>
      <path d="M5 3v7a2 2 0 0 0 4 0V3M7 12v9" />
      <path d="M16 3c-1.5 0-2.5 2-2.5 4.5S14.5 12 16 12v9" />
    </>
  ),
  pizzaSlice: (
    <>
      <path d="M3.5 7.2 12 21l8.5-13.8C15.7 4.4 8.3 4.4 3.5 7.2Z" />
      <circle cx="10" cy="9.5" r="1" fill="currentColor" stroke="none" />
      <circle cx="13.5" cy="12.5" r="1" fill="currentColor" stroke="none" />
    </>
  ),
  cup: (
    <>
      <path d="M6.5 8h11l-1 11.2a2 2 0 0 1-2 1.8H9.5a2 2 0 0 1-2-1.8L6.5 8Z" />
      <path d="M6 8 5.4 5h13.2" />
      <path d="M14.5 5 13 8.5" />
    </>
  ),
  bottle: (
    <>
      <path d="M10 2.5h4v2.6l1 2.2V20a1.8 1.8 0 0 1-1.8 1.8h-2.4A1.8 1.8 0 0 1 9 20V7.3l1-2.2V2.5Z" />
      <path d="M9.2 11h5.6" />
    </>
  ),
  beer: (
    <>
      <rect x="6" y="4" width="9" height="16" rx="1.6" />
      <path d="M15 8h2.6A1.6 1.6 0 0 1 19.2 9.6v4A1.6 1.6 0 0 1 17.6 15.2H15" />
      <path d="M9 8.5v7M12 8.5v7" />
    </>
  ),
  flame: <path d="M12 2.5c2 3.2 4.2 5 4.2 8.2A4.2 4.2 0 0 1 7.8 10.7c0-1.4.7-2.7 1.4-3.4-.2 1.6 1 2.6 1.8 2.6 1.4 0 1.4-2.6-.8-4.6 2.3-.3 2.8-1.6 1.6-2.8Z" />,
  burger: (
    <>
      <path d="M4.5 10.3c0-3.1 3.4-5.3 7.5-5.3s7.5 2.2 7.5 5.3Z" />
      <path d="M3.6 13.4h16.8" />
      <path d="M4.4 16c.7 1.9 3.5 3 7.6 3s6.9-1.1 7.6-3" />
    </>
  ),
  monitor: (
    <>
      <rect x="3" y="4" width="18" height="13" rx="2" />
      <path d="M8.5 21h7M12 17v4" />
    </>
  ),
  smartphone: (
    <>
      <rect x="7" y="3" width="10" height="18" rx="2.6" />
      <path d="M10.5 18h3" />
    </>
  ),
  sliders: (
    <>
      <path d="M4 8h10M18 8h2M4 16h2M10 16h10" />
      <circle cx="16" cy="8" r="2" />
      <circle cx="8" cy="16" r="2" />
    </>
  ),
  steak: (
    <>
      <path d="M5.5 12.5c0-4 3.5-7 8-7s6.5 2.5 6.5 5.5-2.5 5-5.5 5.5c-2 .3-3 1.5-4.5 1.5-2.5 0-4.5-2-4.5-5.5Z" />
      <circle cx="13.5" cy="12.5" r="2.4" />
    </>
  ),
  drumstick: (
    <>
      <path d="M12.8 4.6a4.4 4.4 0 1 1 5.4 5.4c-1 .3-1.7.8-2.4 1.5l-2.6 2.6-4.5-4.5 2.6-2.6c.7-.7 1.2-1.4 1.5-2.4Z" />
      <path d="m9.3 13.9-3 3a2.4 2.4 0 1 0 3.4 3.4l3-3" />
    </>
  ),
  sushi: (
    <>
      <rect x="4" y="12" width="16" height="7" rx="3" />
      <path d="M4.2 12.6C5.5 9 18.5 9 19.8 12.6" />
      <path d="M10.5 10.2v8.8M13.5 10.2v8.8" />
    </>
  ),
  fish: (
    <>
      <path d="M6.5 12c2.3-3.2 5-4.6 7.8-4.6 3.2 0 5.5 1.8 6.9 4.6-1.4 2.8-3.7 4.6-6.9 4.6-2.8 0-5.5-1.4-7.8-4.6Z" />
      <path d="M6.5 12 3 8.5v7L6.5 12Z" />
      <circle cx="16.5" cy="10.6" r="0.6" fill="currentColor" stroke="none" />
    </>
  ),
  salad: (
    <>
      <path d="M4.5 19.5C4.5 11 10 5 20 4.5c.5 9-5.5 15-15.5 15Z" />
      <path d="M4.5 19.5 13 11" />
    </>
  ),
  noodles: (
    <>
      <path d="M3.5 11.5h17a8.5 8.5 0 0 1-17 0Z" />
      <path d="M14.5 3.5 10 11M18 4.8 13 11" />
    </>
  ),
  bowl: (
    <>
      <path d="M3.5 12.5h17a8.5 8.5 0 0 1-17 0Z" />
      <path d="M9 8.8c0-1.3 1-1.9 1-3.3M13 8.8c0-1.3 1-1.9 1-3.3" />
    </>
  ),
  hotDog: (
    <>
      <path d="M4.5 15.5 15.5 4.5a3.5 3.5 0 0 1 4.9 4.9L9.4 20.4a3.5 3.5 0 0 1-4.9-4.9Z" />
      <path d="M8.2 15.8 15.8 8.2" />
    </>
  ),
  bread: (
    <>
      <path d="M4 13.5c0-3.6 3.6-6.5 8-6.5s8 2.9 8 6.5v2A1.5 1.5 0 0 1 18.5 17h-13A1.5 1.5 0 0 1 4 15.5v-2Z" />
      <path d="M9 7.6 7.6 17M14 7.4 12.8 17" />
    </>
  ),
  cake: (
    <>
      <path d="M4.5 13h15v6.5a1.5 1.5 0 0 1-1.5 1.5H6a1.5 1.5 0 0 1-1.5-1.5V13Z" />
      <path d="M4.5 13c1.6 0 1.6-1.8 3.2-1.8S9.3 13 10.9 13s1.6-1.8 3.2-1.8S15.7 13 17.3 13s1.6-1.8 2.2-1.8" />
      <path d="M12 5.5v3.2" />
      <circle cx="12" cy="3.9" r="0.9" />
    </>
  ),
  iceCream: (
    <>
      <path d="M7.5 10.5h9L12 21.2 7.5 10.5Z" />
      <path d="M7.3 10.5a4.7 4.7 0 0 1 9.4 0" />
      <path d="M9.6 14.2h4.8" />
    </>
  ),
  coffee: (
    <>
      <path d="M4.5 8.5h11v6.5a4 4 0 0 1-4 4h-3a4 4 0 0 1-4-4V8.5Z" />
      <path d="M15.5 10h1.9a2.6 2.6 0 0 1 0 5.2h-1.9" />
      <path d="M7.5 4.8v1.6M11 4v2.4" />
    </>
  ),
  wine: (
    <>
      <path d="M7 3.5h10l-1 6a4 4 0 0 1-8 0l-1-6Z" />
      <path d="M12 13.6V20M8.5 20h7" />
    </>
  ),
  externalLink: (
    <>
      <path d="M14 4h6v6" />
      <path d="M10 14 20 4" />
      <path d="M18 14v5A1.5 1.5 0 0 1 16.5 20.5h-11A1.5 1.5 0 0 1 4 19V8a1.5 1.5 0 0 1 1.5-1.5H10" />
    </>
  ),
  copy: (
    <>
      <rect x="9" y="9" width="11" height="11" rx="2" />
      <path d="M5 15V6a2 2 0 0 1 2-2h9" />
    </>
  ),
  share: (
    <>
      <path d="M12 3v12" />
      <path d="m8 7 4-4 4 4" />
      <path d="M5 12v7A1.5 1.5 0 0 0 6.5 20.5h11A1.5 1.5 0 0 0 19 19v-7" />
    </>
  ),
};

export type IconName = keyof typeof ICON_PATHS;

interface IconProps {
  name: string;
  size?: number;
  color?: string;
  strokeWidth?: number;
  fill?: string;
  style?: React.CSSProperties;
}

export default function Icon({
  name,
  size = 22,
  color = "currentColor",
  strokeWidth = 1.9,
  fill,
  style,
}: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fill || "none"}
      stroke={fill ? "none" : color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ display: "block", flexShrink: 0, ...style }}
    >
      {ICON_PATHS[name]}
    </svg>
  );
}
